/**
 * Куда вернуть пользователя после входа. Принимается только путь на этом же сайте:
 * «//host», обратные слеши (в т.ч. %5C) и абсолютные адреса — открытый редирект на фишинговый сайт
 * (react-router GHSA-wrjc-x8rr-h8h6: «/\evil.com» уводит на evil.com) — дают главную.
 */
export function safeReturnTo(raw: string | undefined, origin: string = window.location.origin): string {
  if (!raw || !raw.startsWith('/') || raw.startsWith('//') || /\\|%5c/i.test(raw)) return '/';
  try {
    const u = new URL(raw, origin);
    if (u.origin !== origin || u.pathname.startsWith('/auth-callback')) return '/';
    return u.pathname + u.search + u.hash;
  } catch {
    return '/';
  }
}
